module.exports = __webpack_public_path__ + "img/MobileImage2_en.352c6218.png";